const buildNextUrl = (url: URL) => {
	const search = url.searchParams.toString();
	return `${url.pathname}${search ? `?${search}` : ''}${url.hash}`;
};

export const removeQueryParamFromHistory = (param: string) => {
	if (typeof window === 'undefined') return null;
	const url = new URL(window.location.href);
	if (!url.searchParams.has(param)) return null;
	url.searchParams.delete(param);
	const nextUrl = buildNextUrl(url);
	window.history.replaceState(null, '', nextUrl);
	return nextUrl;
};

export const upsertQueryParamInHistory = (param: string, value: string) => {
	if (typeof window === 'undefined') return null;
	const url = new URL(window.location.href);
	if (url.searchParams.get(param) === value) return null;
	url.searchParams.set(param, value);
	const nextUrl = buildNextUrl(url);
	window.history.replaceState(null, '', nextUrl);
	return nextUrl;
};

export const buildCreatorProjectShareUrl = (projectId: string) => {
	if (typeof window === 'undefined') return '';
	const url = new URL(window.location.origin + window.location.pathname);
	url.searchParams.set('previewId', projectId);
	return url.toString();
};

/** Public, shareable preview URL for emails (uses deployed app URL, not embed origin). */
export const buildCreatorProjectPreviewUrl = (projectId: string) => {
	const configured = String(import.meta.env.VITE_APP_URL || '').trim();
	const origin =
		configured || (typeof window !== 'undefined' ? window.location.origin : '');
	if (!origin || !projectId) return '';
	try {
		const url = new URL(origin);
		url.search = '';
		url.hash = '';
		url.searchParams.set('previewId', projectId);
		return url.toString();
	} catch {
		return '';
	}
};
